<template>
  <v-card flat v-if="edition">
    <v-layout row align-center>
      <v-flex xs12>
        <v-card-text class="py-1">
            <v-layout row wrap fill-height align-center>
                <v-flex xs12>
                  <v-text-field label="Nome" v-model="form.productname" 
                    clearable v-if="form.product_id || form._id" autofocus
                    :error-messages="itemErrors"
                  >
                  </v-text-field>
                  <v-combobox
                    @input="selectProduct"
                    :items="products"
                    :loading="loadingSearch"
                    :search-input.sync="search"
                    clearable
                    hide-selected
                    no-filter
                    item-text="productname"
                    label="Nome do produto"
                    browser-autocomplete="none"
                    hide-no-data
                    autofocus
                    v-else
                    :error-messages="itemErrors"
                  >
                    <!-- <template v-slot:no-data>
                      <v-list-tile>
                        <v-list-tile-title>
                          Search for your favorite
                          <strong>Cryptocurrency</strong>
                        </v-list-tile-title>
                      </v-list-tile>
                    </template> -->
                    <template v-slot:item="{ item }">
                      <v-list-tile-avatar
                        color="primary"
                      >
                        <v-img :src="uri+((item.photo)?item.photo:item.categoria_photo)"></v-img>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-text="item.productname"></v-list-tile-title>
                        <v-list-tile-sub-title v-text="'R$'+price(item.price)"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-combobox>
                </v-flex>
                <v-flex xs12>
                  <v-textarea label="Descrição" v-model="form.description"
                    rows="1" auto-grow
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs3 v-if="!hidePrice">
                  <v-text-field  
                  label="Preço" type="text"
                  v-money="config"
                  v-model.lazy="form.price"
                  ref="price"
                  prefix="R$"
                  required
                  ></v-text-field>
                </v-flex>
                <v-flex>
                  <v-btn icon small @click="save" :loading="loading" color="success">
                    <v-icon>done</v-icon>
                  </v-btn>
                  <v-btn icon small @click="close" color="red" dark>
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
            </v-layout>
        </v-card-text>
      </v-flex>
    </v-layout>
    <v-divider divider class="pa-1"></v-divider>
  </v-card>
  <v-card flat v-else>
    <v-layout row>
      <v-flex xs10>
        <v-card-text class="py-1">
            <v-layout row align-end>
                <v-flex xs12>
                  <v-chip class="ml-0" outline small color="error" 
                  v-if="item.active !== undefined && !item.active"
                  :disabled="loading"
                  close @input="activeProduct">
                    Inativo
                  </v-chip>
                  <span class="subheading">{{item.productname}}</span>
                  <span class="grey--text body-1">
                  <br>
                  {{item.description}}
                  </span>
                  <span class="grey--text body-1" v-if="!hidePrice">
                  <br>
                  R${{price(item.price)}}
                  </span>
                </v-flex>
            </v-layout>
        </v-card-text>
      </v-flex>
      <v-flex v-if="!hideActions">
        <v-card-actions>
          <v-btn icon small @click="edit()">
            <v-icon color="accent">edit</v-icon>
          </v-btn>
          <v-btn icon small @click="$emit('delete',item.product_id)">
            <v-icon color="red">delete</v-icon>
          </v-btn>
        </v-card-actions>
      </v-flex>
    </v-layout>
    <v-divider divider class="pa-1"></v-divider>
  </v-card>
</template>

<script>
export default {
  props:['item','hide-price','hide-actions','product-list'],
  data(){
    return{
      edition:false,
      config: {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2},
      form:{
        productname:"",
        description:"",
        price:0.00,
        active:true
      },
      loading:false,
      error:null,
      loadingSearch:false,
      search:"",
      products:[],
      uri:'https://api.socialplace.com.br',
      itemErrors:[]
    }
  },
  mounted(){
    if(!this.item.product_id)
      this.edit()
  },
  watch:{
    edition(v){
      this.$emit('editing',v)
    },
    async search (val) {
      this.form.productname = val 
      if (!this.search || (this.search && this.search.length < 3)){
        this.products = []
        return
      }

      this.loadingSearch = true
      try {
        const data = {
          search:val,
          skipCommit:true
        }
        const res = await this.$store.dispatch('fetchProducts',data)
        this.products = res.data.filter(p=>this.productList.indexOf(p._id)==-1)
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingSearch = false
      }
    }
  },
  methods:{
    activeProduct(){
      this.edit(true)
      this.form.active = true
      this.save()
    },
    selectProduct(v){
      if(v && v._id){
        this.edition = false
        this.$emit('newItem',v._id)
      }
    },
    price(v){
      return Number(v).toFixed(2).toString().replace('.',',')
    },
    edit(dontShow){
      this.form = Object.assign({},this.item)
      if(!dontShow){
        this.form.price = Math.round(this.form.price * 100)
        this.edition = true
      }
    },
    async save(){
      this.form.productname = this.form.productname || ""
      if(!this.form.productname.trim()){
        this.itemErrors = ['Informe o nome do produto']
        return
      }else{
        this.itemErrors = []
      }
      this.loading = true
      const data = {
        ...this.form,
      }
      
      if(this.form.product_id || this.form._id){
        data.product_id = data._id
        this.$store.dispatch('updateProduct',this.form).then(res=>{
          this.$emit('refresh')
          this.loading = this.edition = false
        }).catch(err=>{
            this.error = err
            console.log(err)
            this.loading = false
        })
      }else{
        data.type="Produtos combo",
        data.hide_type=true,
        data.code=await this.$store.dispatch('generateCode'),
        data.photo=""
        this.$store.dispatch('createProduct',data).then(res=>{
          this.loading = this.edition = false
          this.$emit('newItem',res._id)
        }).catch(err=>{
            this.error = err
            console.log(err)
            this.loading = false
        })
      }
    },
    close(){
      this.edition=false
      setTimeout(() => {
        if(!this.item.product_id)
          this.$emit('delete',null)
      }, 200);
    }
  }
}
</script>

<style>

</style>